<template>
  <nx-fullscreen-dialog
      :active="active"
      :title="blockTitle"
      @dismiss="dismiss">

    <template slot="toolbar-items">
      <v-btn
          :disabled="!isValid"
          @click="insertBlot"
          color="accent"
          flat
          v-html="buttonTitle"
      ></v-btn>
    </template>

    <v-container pb-3 fluid>
      <v-layout>
        <v-flex class="md6 offset-md3 sm10 offset-sm1 pt-4">
          <v-layout row wrap>

            <v-flex class="xs12">
              <h2 class="nx-block-headline" v-html="formTitle"></h2>

              <v-text-field
                  :error-messages="error"
                  :label="twitterTitle"
                  :placeholder="placeholderTitle"
                  @input="loadPreview"
                  autofocus
                  v-model="url"
              ></v-text-field>

              <v-checkbox :label="$t('message.block.form.tweet.hideThread')" v-model="formHideThread"></v-checkbox>
              <v-checkbox :label="$t('message.block.form.tweet.optOutTailoring')" v-model="formOptOutTailoring"></v-checkbox>

              <div ref="preview"></div>
            </v-flex>

          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>


  </nx-fullscreen-dialog>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import DialogButton from './DialogButton';
import { delay } from '@/utils';

/**
 * TwitterButton Component
 *
 * Extend DialogButton component
 *
 */

const regex = new RegExp('^(?:https?://)?(?:www\\.)?(twitter|x)\\.com/.+/status(?:es)?/(\\d+).*$', 'i');

export default {
  name: 'nx-twitter-button',
  extends: DialogButton,
  props: {
    embedId: [String, Number],
    embedHideThread: String,
    embedOptOutTailoring: String,
  },
  data() {
    return {
      name: 'tweetEmbed',
      data: {
        id: this.embedId,
        hideThread: this.embedHideThread === 'true',
        optOutTailoring: this.embedOptOutTailoring === 'true',
        options: {
          align: 'center',
          conversation: this.embedHideThread === 'true' ? 'none' : '',
        },
      },
      url: this.embedId ? `https://x.com/tweet/status/${this.embedId}` : '',
      formHideThread: this.embedHideThread === 'true',
      formOptOutTailoring: this.embedOptOutTailoring === 'true',
    };
  },
  computed: {
    blockTitle() {
      return this.$t('message.block.twitter');
    },
    twitterTitle() {
      return this.$t('message.block.form.twitter');
    },
    placeholderTitle() {
      return this.$t('message.block.form.twitterPlaceholder');
    },
    isValid() {
      return !isEmpty(this.data.id)
        && isEmpty(this.error);
    },
  },
  watch: {
    url(url) {
      const matches = regex.exec(url);
      if (!matches || !Array.isArray(matches) || isEmpty(matches[1])) {
        this.data.id = '';
        this.error = [this.$t('message.block.form.twitterErrorUrl')];
        this.cleanupPreview();
      } else {
        this.data.id = matches[2];
        this.error = [];
        this.loadPreview();
      }
    },
    formHideThread(value) {
      if (value === true) {
        this.data.options.conversation = 'none';
      } else {
        delete this.data.options.conversation;
      }
      this.data.hideThread = value;
      this.loadPreview();
    },
    formOptOutTailoring(value) {
      if (value === true) {
        this.data.options.adds = 'none';
      } else {
        delete this.data.options.adds;
      }
      this.data.optOutTailoring = value;
      this.loadPreview();
    },
  },
  async mounted() {
    await delay(300);
    await this.loadPreview();
  },
  methods: {
    async loadScript() {
      return ((d, s, id) => {
        let js = null;

        const fjs = d.getElementsByTagName(s)[0];
        const t = window.twttr || {};

        if (d.getElementById(id)) return t;

        js = d.createElement(s);
        js.id = id;
        js.src = 'https://platform.twitter.com/widgets.js';
        // js.onload();
        fjs.parentNode.insertBefore(js, fjs);

        t._e = [];

        t.ready = (f) => {
          t._e.push(f);
        };

        return t;
      })(document, 'script', 'twitter-wjs');
    },
    async loadTweet() {
      window.twttr.widgets.createTweet(
        this.data.id,
        this.$refs.preview,
        this.data.options,
      )
        .then((el) => {
          if (el !== undefined) {
            return;
          }
          this.data.id = '';
          this.error = [this.$t('message.block.form.twitterErrorTweet')];
          this.cleanupPreview();
        });
    },
    async loadPreview() {
      this.cleanupPreview();
      if (!this.isValid) {
        return;
      }
      if (!window.twttr) {
        window.twttr = await this.loadScript();
        window.twttr.ready(() => this.loadTweet());
      } else {
        await this.loadTweet();
      }
    },
  },
};
</script>
